import { useState } from 'react';
import { Radio, RadioGroup } from '@ds';
import { SelectSecondaryCS } from './SelectSecondaryCS';
import { SelectSecondaryS } from './SelectSecondaryS';
import { SelectSecondaryOCS } from './SelectSecondaryOCS';

enum SecondaryResourceType {
  CS = 'CS',
  S = 'S',
  OCS = 'OCS',
}

type SecondaryResourceSelectProps = {
  onClose: () => void;
  setParentLoading?: (loading: boolean) => void;
};

export const SecondaryResourceSelect = ({ onClose, setParentLoading }: SecondaryResourceSelectProps) => {
  const [selected, setSelected] = useState<SecondaryResourceType>(SecondaryResourceType.CS);

  const renderContent = () => {
    switch (selected) {
      case SecondaryResourceType.CS:
        return <SelectSecondaryCS setParentLoading={setParentLoading} onClose={onClose} />;
      case SecondaryResourceType.OCS:
        return <SelectSecondaryOCS setParentLoading={setParentLoading} onClose={onClose} />;
      case SecondaryResourceType.S:
        return <SelectSecondaryS setParentLoading={setParentLoading} onClose={onClose} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col p-0 gap-6">
      <RadioGroup
        className="gap-4 p-0"
        value={selected}
        onValueChange={(value) => setSelected(value as SecondaryResourceType)}
        orientation="horizontal"
      >
        <Radio value={SecondaryResourceType.CS}>Clinical Specialist</Radio>
        <Radio value={SecondaryResourceType.S}>Retrieval Surgeon</Radio>
        <Radio value={SecondaryResourceType.OCS}>Device</Radio>
      </RadioGroup>
      <div>{renderContent()}</div>
    </div>
  );
};
